export const WORK_SHIFT_INVOICE_TASKS_LIMIT = 20;

export const WORK_SHIFT_CLOSE_DELAY_DAYS = 1;

export const WORK_SHIFT_PLAN_MIN = 1;

export const WORK_SHIFT_PLAN_MAX = 1000;

export const WORK_SHIFT_MANUAL_CLOSE_REASON_MAX_LENGTH = 512;
